export class ArgoCDInstanceLinks {
    private readonly baseUri: string;

    constructor(baseUri: string) {
        this.baseUri = baseUri.endsWith("/") ? baseUri.slice(0, -1) : baseUri;
    }

    public root() {
        return this.baseUri;
    }

    public applicationDetails(name: string, namespace: string) {
        return `${this.baseUri}/applications/${namespace}/${name}`;
    }
}
